import Icon from "components/AppIcon";

const InfoRow = ({ icon, label, value, className = '' }) => {
    return(
        <div className={`flex items-start space-x-3 ${className}`}>
            <Icon name={icon} size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-muted-foreground">{label}</div>
                <div className="text-foreground break-words">{value || 'Not provided'}</div>
            </div>
        </div>
    )
};

export default InfoRow;